import React from 'react';
import PropTypes from 'prop-types';

class IframeForm extends React.PureComponent {
    static propTypes = {
        payment_processor: PropTypes.object.isRequired,
        payment_processor_iframe_url: PropTypes.string,
    };

    constructor() {
        super();

        this.state = {
            loading: false,
        };
        this.start_load_time = null;
        this.load_interval = null;
        this.iframe = null;
    }

    bindIframeOnloadHandler = () => {
        if (this.iframe) {
            this.iframe.addEventListener('load', this.onIframeLoad);
        }
    };

    unbindIframeOnloadHandler = () => {
        if (this.iframe) {
            this.iframe.removeEventListener('load', this.onIframeLoad);
        }
    };

    loadStarted = () => {
        this.setState(
            {
                loading: true,
            },
            () => {
                this.start_load_time = +new Date();
                Mobi2Go.Order.log('payment iframe started loading', {
                    iframe_url: this.props.payment_processor_iframe_url,
                });

                this.bindIframeOnloadHandler();
                this.clearLoadIntervalCheck();
                this.load_interval = setInterval(this.loadIntervalCheck, 20000);
            }
        );
    };

    clearLoadIntervalCheck = () => {
        if (this.load_interval) {
            clearInterval(this.load_interval);
            this.load_interval = null;
        }
    };

    loadIntervalCheck = () => {
        // trigger refresh
        this.unbindIframeOnloadHandler();
        if (this.iframe) {
            this.iframe.src = '';
            setTimeout(() => {
                this.bindIframeOnloadHandler();
                this.iframe.src = this.props.payment_processor_iframe_url;
            }, 0);
        }
    };

    loadFinished = e => {
        this.unbindIframeOnloadHandler();
        this.clearLoadIntervalCheck();
        Mobi2Go.Order.log('payment iframe finished loading', {
            iframe_url: this.props.payment_processor_iframe_url,
            seconds_to_load: (+new Date() - this.start_load_time) / 1000,
        });
        Mobi2Go.Order.save();
        this.setState({
            loading: false,
        });
    };

    loadCancelled = () => {
        this.clearLoadIntervalCheck();
        this.setState({
            loading: false,
        });
    };

    onIframeLoad = () => {
        this.loadFinished();
    };

    componentDidMount() {
        if (this.props.payment_processor_iframe_url !== null) {
            this.loadStarted();
        }
    }

    componentWillUnmount() {
        this.loadCancelled();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.payment_processor_iframe_url !==
                nextProps.payment_processor_iframe_url &&
            nextProps.payment_processor_iframe_url !== null
        ) {
            this.loadStarted();
        }
    }

    render() {
        return (
            <div className="m2g-order-confirmation-payment-processor-iframe">
                {this.props.payment_processor_iframe_url && (
                    <div
                        className="m2g-order-confirmation-payment-processor-iframe-container"
                        data-container
                        style={{
                            display: this.state.loading ? 'none' : 'block',
                        }}
                    >
                        <iframe
                            ref={el => (this.iframe = el)}
                            src={this.props.payment_processor_iframe_url}
                        />
                    </div>
                )}

                <div className="m2g-order-confirmation-payment-processor-iframe-loader">
                    <div
                        className="m2g-order-confirmation-payment-processor-logo m2g-payment-processor-logo"
                        data-processor-logo
                    >
                        <img
                            src={this.props.payment_processor.getLogoUrl()}
                            alt={`${this.props.payment_processor.name} Logo`}
                        />
                    </div>
                    <div className="m2g-icon m2g-icon--spinner" />
                </div>
            </div>
        );
    }
}

export default IframeForm;
